module.exports = __webpack_public_path__ + "img/logo.e10629e5.png";